import { React } from 'react';

// Placeholder shell — no data source/API has been defined for this grid yet.
const Payable = ({ tableLoading }) => {
    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                {tableLoading && (
                    <div
                        style={{
                            position: 'absolute',
                            inset: 0,
                            background: 'rgba(255,255,255,0.6)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                        }}
                    >
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                )}
                <table className="table">
                    <thead>
                        <tr>
                            <th>Value</th>
                            <th>Description</th>
                            <th>Landlord</th>
                            <th>Tenant</th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>
        </div>
    );
};
export default Payable;
